import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Form, Button, Grid } from 'semantic-ui-react';

// Components
// @ts-ignore
import SubmittingButton from '../../../../../../../../components/SubmittingButton';

// Actions
// @ts-ignore
import { requestDeleteWorkType } from '../../../../../../../../services/workTypes/actions';

interface Props {
    workTypeId: number;
    requestDeleteWorkType: Function;
    handleSubmit: Function;
    onClose: Function;
}

export class DeleteWorkTypeForm extends React.PureComponent<Props> {
    handleSubmit = () => {
        const { workTypeId } = this.props;
        this.props.requestDeleteWorkType(workTypeId);
    };

    render(): React.ReactElement {
        const { handleSubmit, onClose } = this.props;

        return (
            <Form
                onSubmit={handleSubmit(this.handleSubmit)}
                autoComplete="off"
            >
                <Grid>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <Button
                            type="button"
                            onClick={() => onClose()}
                            fluid
                            basic
                            primary
                        >
                            Cancel
                        </Button>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <SubmittingButton
                            type="submit"
                            namespace="WORK_TYPE_DELETE"
                            negative
                            fluid
                        >
                            Delete
                        </SubmittingButton>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}

export default connect(
    null,
    { requestDeleteWorkType }
)(
    reduxForm<any, any>({
        form: 'WORK_TYPE_DELETE'
    })(DeleteWorkTypeForm)
);
